/**
 * API facade — composes the per-feature endpoint groups (split along the same
 * axis as the backend routers, `backend/app/api/`) into the single `api`
 * object every page consumes, and re-exports the types pages use.
 */

import { aceApi } from './ace'
import { adminApi } from './admin'
import { analysisApi } from './analysis'
import { assessmentsApi } from './assessments'
import { assistantApi } from './assistant'
import { awsImportApi } from './aws-import'
import { clarificationsApi } from './clarifications'
import { companiesApi } from './companies'
import { generateApi } from './generate'
import { intakeApi } from './intake'
import { partnerCentralApi } from './partnerCentral'
import { proposalsApi } from './proposals'
import { researchApi } from './research'
import { settingsApi } from './settings'
import { signoffApi } from './signoff'
import { submissionApi } from './submission'
import { transcriptReviewApi } from './transcriptReview'
import { wafrReviewApi } from './wafrReview'

export { StaleStateError } from './core'

export type {
  AceCandidate,
  AceSearchResponse,
  AgentProposal,
  ArchitectureStatus,
  AnalysisResult,
  AnalysisSuggestion,
  AssessmentMeta,
  AssessmentState,
  AssistantChange,
  AssistantContext,
  AssistantResponse,
  Company,
  ModuleQuestionnaire,
  AwsAccountOutput,
  AwsConnectionOutput,
  AwsConnectionPayload,
  AwsPlatformIdentity,
  Clarification,
  ConnMethod,
  FieldMeta,
  JobStatus,
  PendingFinding,
  ProposalPatch,
  ProposalSuggestion,
  ResearchResponse,
  TranscriptReviewResponse,
  TranscriptSummary,
  WafrEvidenceRef,
  WafrFundingRequest,
  WafrItem,
  WafrReviewMeta,
  WafrReviewState,
} from './types'

export type {
  AuditAssessment,
  AuditEntry,
  AuditPage,
  PlaybookPlay,
  PlaybooksResponse,
} from './admin'
export type { DeliverableFile } from './generate'
export type { AIProposalsSnapshot, UseCaseHypothesis } from './proposals'
export type { SettingDef, SettingsResponse } from './settings'
export type { SignoffSummary } from './signoff'

export const api = {
  ...aceApi,
  ...adminApi,
  ...analysisApi,
  ...assessmentsApi,
  ...assistantApi,
  ...intakeApi,
  ...researchApi,
  ...proposalsApi,
  ...clarificationsApi,
  ...awsImportApi,
  ...companiesApi,
  ...generateApi,
  ...submissionApi,
  ...transcriptReviewApi,
  ...settingsApi,
  ...signoffApi,
  ...partnerCentralApi,
  ...wafrReviewApi,
}
